import { useSelector } from 'react-redux';

import MeasurementComparisonComponent from '../components/MeasurementComparisonComponent';
import {
  getCurrentMeasurementValue,
  getDimensionalPrecision,
  getDisplayScale,
  getDisplayUnits,
  getMeasurementComparison,
  getNativeUnits,
} from '../data/reducer';

const MeasurementComparisonDisplay = ({ isEnabled }) => {
  const comparison = useSelector(getMeasurementComparison);
  const currentMeasurementValue = useSelector(getCurrentMeasurementValue);
  const displayScale = useSelector(getDisplayScale);
  const displayUnits = useSelector(getDisplayUnits);
  const nativeUnits = useSelector(getNativeUnits);
  const dimensionalPrecision = useSelector(getDimensionalPrecision);

  return isEnabled ? (
    <MeasurementComparisonComponent
      comparison={comparison}
      currentMeasurementValue={currentMeasurementValue}
      displayScale={displayScale}
      displayUnits={displayUnits}
      nativeUnits={nativeUnits}
      dimensionalPrecision={dimensionalPrecision}
    />
  ) : null;
};

export default MeasurementComparisonDisplay;
